/* ==========================================================================
   SPLASH Hourly Draw — the page's behaviour.
   Reads everything from SplashHourly (hourly-data.js) and draws it. It never
   talks to the chain itself. No inline styles or scripts: it toggles classes,
   sets SVG attributes and a couple of custom properties through the CSSOM.
   ========================================================================== */
(function () {
  'use strict';

  var RING = 804.25;                 // circumference of the clock ring (r = 128)
  var MAX_ENTRIES = 100;
  var STILL_LOADING_MS = 8000;

  var body = document.body;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function setText(sel, text) { $$(sel).forEach(function (n) { n.textContent = text; }); }
  function make(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  var el = {
    lagoon: $('[data-lagoon]'),
    splashes: $('[data-splashes]'),
    arc: $('[data-arc]'),
    arcEdge: $('[data-arc-edge]'),
    countdown: $('[data-countdown]'),
    winner: $('[data-winner]'),
    statusText: $('[data-status-text]'),
    retry: $('[data-retry]'),
    picks: $$('[data-pick]'),
    other: $('[data-other]'),
    buy: $('[data-buy]'),
    after: $('[data-after]'),
    history: $('[data-history]'),
    rehearsal: $('[data-rehearsal]'),
    wallet: $('[data-wallet]'),
    stalled: $('[data-stalled]'),
    guest: $('[data-guest]'),
    foot: $('[data-foot]'),
    toast: $('[data-toast]'),
    announce: $('[data-announce]')
  };

  var state = null;
  var prev = null;
  var qty = 1;
  var lastPick = 1;
  var buying = false;
  var closeAt = 0;
  var loadingTimer = 0;
  var toastTimer = 0;

  /* ---- Formatting: honest units ------------------------------------------------ */
  function gnot(n) { return Number(n).toLocaleString('en-IE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function whole(n) { return Math.round(n).toLocaleString('en-IE'); }

  // THE SENTENCE THAT WAS MISSING ENTIRELY. Three states, because the honest
  // answer genuinely differs and guessing in either direction misleads:
  // no entries yet (nothing is pinned, so there is no time to give), pinned
  // (say the clock time, from the beacon's own TimeOfRound), or pinned but
  // the time could not be read (say so rather than invent one).
  function payoutLine(s) {
    if (!s.randomnessRound) {
      return 'nobody is in yet. The winning number is picked when the first '
        + 'ticket is bought, and lands about two hours after that — the gap is '
        + 'what stops anyone seeing it coming.';
    }
    if (!s.payoutAt) {
      return 'about two hours after the first ticket was bought. The gap is what '
        + 'stops anyone seeing the number coming.';
    }
    var d = new Date(s.payoutAt * 1000);
    var hhmm = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    return 'around ' + hhmm + ', when drand round ' + whole(s.randomnessRound) + ' lands — '
      + 'about two hours after entries close, not the moment they do. '
      + 'That gap is what stops anyone seeing the number coming.';
  }
  function pct(part, total) {
    if (!total || !part) return '0%';
    var p = part / total * 100;
    if (p >= 99.95) return '100%';
    return (p >= 10 ? (Math.floor(p * 10) / 10).toFixed(1) : (Math.floor(p * 100) / 100).toFixed(2)) + '%';   // round down, never up
  }
  function who(addr) { return addr === 'you' ? 'You' : addr.slice(0, 6) + '…' + addr.slice(-4); }
  function clock(secs) {
    secs = Math.max(0, Math.ceil(secs));
    return Math.floor(secs / 60) + ':' + String(secs % 60).padStart(2, '0');
  }
  function entriesWord(n) { return n === 1 ? 'entry' : 'entries'; }

  function toast(message) {
    el.toast.textContent = message;
    el.toast.classList.add('is-shown');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { el.toast.classList.remove('is-shown'); }, 3600);
  }
  function announce(message) { el.announce.textContent = message; }
  function isFresh(s) { return s.phase === 'open' && s.entries.total === 0; }

  /* ---- The clock --------------------------------------------------------------------- */
  function tick() {
    if (!state) return;
    var windowSecs = state.windowBlocks * state.secondsPerBlock;
    var left = (closeAt - Date.now()) / 1000;
    var open = state.phase === 'open';
    var frac = open ? Math.min(1, Math.max(0, 1 - left / windowSecs)) : 1;
    var offset = String(RING * (1 - frac));
    el.arc.setAttribute('stroke-dashoffset', offset);
    el.arcEdge.setAttribute('stroke-dashoffset', offset);
    el.lagoon.classList.toggle('is-final', open && left <= 10 && left > 0);

    if (state.phase === 'drawing') {
      el.countdown.textContent = 'Drawing…';
      setText('[data-countdown-label]', 'Picking the winner');
    } else if (open) {
      el.countdown.textContent = left > 0 ? clock(left) : '0:00';
      // "Until the draw" WAS WRONG and it is the kind of wrong that makes a
      // working game look broken. This clock counts to the block where
      // ENTRIES CLOSE. The winner is paid when the pinned drand round lands,
      // about two hours later -- that gap is the security margin and it is
      // deliberate. A player watching an "hourly" draw reach 0:00 and then
      // seeing nothing for two hours concludes, reasonably, that it is
      // stuck. Flagged 2026-10-08 after the owner hit exactly this.
      setText('[data-countdown-label]', left > 0 ? 'Until entries close' : 'Closing…');
    }
  }

  /* ---- Drawing everything ---------------------------------------------------------- */
  function renderTop(s) {
    el.rehearsal.hidden = !s.rehearsal;
    setText('[data-rehearsal-text]', 'Pretend GNOT — nothing here is on a chain yet. ' + s.network + ' itself is at block ' + whole(s.networkHeight) + '.');
    var guest = s.rehearsal && s.entries.mine !== null;
    el.guest.hidden = !guest;
    el.wallet.hidden = guest;

    renderWallet(s);

    // THE UNSETTLED BANNER. Shown when a window that is over has not been settled --
    // read from the chain, so it is right whether our keeper is dead, broke or
    // was never running. It tells the player the money is safe and that ANYBODY
    // can finish it, because both are true and the second is the whole reason
    // the calls are permissionless.
    // IT HAS TO SAY WHAT SETTLING IS, AND WHETHER ANYONE CAN ACTUALLY DO IT.
    // The old copy said "settling is an open call \u2014 anyone can finish it" in
    // every case, with no explanation of the word and no action. Flagged by
    // the owner on 2026-10-08 looking at the live site: "there is a banner
    // saying for someone to settle it, but no instruction how to settle or
    // what settling even means". He was right twice over -- it was also
    // saying anyone could finish it while the window was waiting on a drand
    // round that did not exist yet, when in fact nobody could.
    if (s.stalled) {
      el.stalled.hidden = false;
      var head = 'Window ' + s.stalled.index + ' closed and the winner has not been paid yet. '
        + 'The ' + gnot(s.stalled.pot) + ' GNOT is still in the contract \u2014 nobody can touch it except whoever wins.';
      var tail;
      if (s.stalled.due === false) {
        // The honest common case. Not stuck, not abandoned: early.
        tail = ' It is waiting on drand round ' + whole(s.stalled.round)
          + ', which has not happened yet. Nobody can finish it before then, including us. '
          + 'It settles by itself shortly after that number exists.';
      } else if (s.stalled.due === true) {
        tail = ' Round ' + whole(s.stalled.round) + ' has happened, so it can be finished now. '
          + 'Our keeper does this automatically within a minute or two \u2014 but it is an open call, '
          + 'so if we ever stopped, anyone could finish it and the winner would still be paid.';
      } else {
        tail = ' Finishing it is an open call \u2014 we do it automatically, and anyone else could.';
      }
      setText('[data-stalled-text]', head + tail);
    } else {
      el.stalled.hidden = true;
    }
    setText('[data-window]', String(s.window));
    setText('[data-close-block]', whole(s.closeBlock));
  }

  function renderLagoon(s) {
    el.lagoon.classList.toggle('is-drawing', s.phase === 'drawing');
    el.lagoon.classList.toggle('is-drawn', s.phase === 'drawn');
    if (s.phase === 'drawn' && s.winner) {
      el.winner.textContent = s.winner.you ? 'You took it — ' + gnot(s.winner.amount) + ' GNOT' : who(s.winner.address) + ' took ' + gnot(s.winner.amount) + ' GNOT';
      el.winner.hidden = false;
    } else {
      el.winner.hidden = true;
    }
    closeAt = Date.now() + Math.max(0, s.closeBlock - s.currentBlock) * s.secondsPerBlock * 1000;
    tick();
  }

  function renderPot(s) {
    setText('[data-pot]', gnot(s.pot));
    setText('[data-entries]', whole(s.entries.total));
    setText('[data-entries-word]', entriesWord(s.entries.total));
    var mine = s.entries.mine;
    setText('[data-you]', mine === null ? 'Connect a wallet to see yours'
      : mine === 0 ? (s.entries.total ? "You're not in yet" : "Nobody's in yet")
      : 'You hold ' + whole(mine) + ' — ' + pct(mine, s.entries.total));
  }

  function renderGetIn(s) {
    el.picks.forEach(function (b) { b.setAttribute('aria-pressed', String(!el.other.value && Number(b.dataset.pick) === qty)); });
    el.other.classList.toggle('is-on', !!el.other.value);
    setText('[data-cost]', whole(qty * s.entry.price));
    setText('[data-cost-entries]', whole(qty) + ' ' + entriesWord(qty));

    var open = s.phase === 'open';
    var fresh = isFresh(s);
    el.buy.disabled = !open || buying;
    el.buy.textContent = buying ? 'Waiting for the block…'
      : !open ? 'This hour has closed'
      : (fresh ? 'Be first in — ' : 'Get in — ') + whole(qty * s.entry.price) + ' GNOT';

    var mine = s.entries.mine || 0;
    var lead = fresh && mine === 0
      ? "You'd hold " + whole(qty) + ' of ' + whole(qty) + ' — 100%, until someone else joins.'
      : "You'd hold " + whole(mine + qty) + ' of ' + whole(s.entries.total + qty) + ' — ' + pct(mine + qty, s.entries.total + qty) + '.';
    var house = ' ' + gnot(s.entry.price * s.entry.houseShare) + ' of each GNOT is held for the house; if this hour never draws, you get it all back.';
    el.after.replaceChildren(make('strong', '', lead), document.createTextNode(house + (s.rehearsal ? ' Pretend GNOT — this is a rehearsal.' : '')));
  }

  function renderProof(s) {
    setText('[data-fair-block]', whole(s.closeBlock));
    setText('[data-fair-round]', whole(s.randomnessRound));
    setText('[data-fair-payout]', payoutLine(s));
    setText('[data-fair-house]', Math.round(s.entry.houseShare * 100) + '%');
    setText('[data-realm]', s.realm);
  }

  function renderHistory(s) {
    var frag = document.createDocumentFragment();
    s.history.slice(0, 3).forEach(function (h) {
      var li = make('li', 'hhist__item');
      var whoBox = make('div', 'hhist__who');
      whoBox.append(make('strong', '', who(h.winner)), document.createTextNode(whole(h.entries) + ' ' + entriesWord(h.entries) + ' · drand ' + whole(h.round)));
      li.append(make('span', 'hhist__win', 'Window ' + h.window), whoBox, make('span', 'hhist__amount', gnot(h.amount)));
      frag.appendChild(li);
    });
    el.history.replaceChildren(frag);
  }

  function renderFoot(s) {
    var inner = make('div', 'foot__inner');
    // fair__realm: see duel-view.js's renderFoot for the full reasoning. The short
    // version is that this line is a 40-character unbroken package path, and
    // splash.css's word-break rule is hooked on that class. THIS PAGE'S OVERFLOW
    // WAS THE HARDEST TO FIND because the span's own bounding box fits (358px
    // inside 390) while its CONTENT does not (scrollWidth 443) -- so a check that
    // asks "does any element's right edge pass the viewport" cannot see it, which
    // is exactly the check that missed it twice.
    inner.append(make('span', 'fair__realm', 'Realm ' + s.realm), make('span', '', 'Entries in wrapped GNOT' + (s.rehearsal ? ' · rehearsal build' : '')));
    el.foot.replaceChildren(inner);
  }

  function render(next) {
    prev = state;
    state = next;
    window.clearTimeout(loadingTimer);
    body.classList.remove('is-loading', 'is-offline');
    renderTop(next);
    renderLagoon(next);
    renderPot(next);
    renderGetIn(next);
    renderProof(next);
    renderHistory(next);
    renderFoot(next);

    if (prev && prev.phase !== 'drawn' && next.phase === 'drawn' && next.winner) {
      announce(next.winner.you ? 'You won this hour: ' + gnot(next.winner.amount) + ' GNOT.' : who(next.winner.address) + ' won this hour.');
    }
    if (prev && prev.window !== next.window) {
      resetPick();
      renderGetIn(next);
      announce('Window ' + next.window + ' is open.');
    }
  }

  /* ---- Someone gets in: a splash on the water --------------------------------------- */
  function splash(count) {
    if (reduceMotion.matches) return;
    for (var i = 0; i < Math.min(count, 3); i++) {
      window.setTimeout(function () {
        var s = make('span', 'splash');
        s.style.setProperty('--x', (12 + Math.random() * 76) + '%');
        s.style.setProperty('--y', (14 + Math.random() * 72) + '%');
        s.addEventListener('animationend', function () { s.remove(); });
        el.splashes.appendChild(s);
      }, i * 160);
    }
  }

  /* ---- Choosing how many --------------------------------------------------------------- */
  function resetPick() {
    qty = 1;
    lastPick = 1;
    el.other.value = '';
  }

  el.picks.forEach(function (b) {
    b.addEventListener('click', function () {
      qty = Number(b.dataset.pick);
      lastPick = qty;
      el.other.value = '';
      if (state) renderGetIn(state);
    });
  });
  el.other.addEventListener('input', function () {
    var v = parseInt(el.other.value, 10);
    if (!el.other.value || isNaN(v) || v < 1) { qty = lastPick; }
    else { qty = Math.min(v, MAX_ENTRIES); if (v > MAX_ENTRIES) el.other.value = String(MAX_ENTRIES); }
    if (state) renderGetIn(state);
  });

  el.buy.addEventListener('click', function () {
    if (!state || state.phase !== 'open' || buying) return;
    var count = qty;
    buying = true;
    renderGetIn(state);
    window.SplashHourly.buyEntries(count).then(function (res) {
      var msg = "You're in — " + whole(res.entries) + (state.rehearsal ? ' pretend ' : ' ') + entriesWord(res.entries) + ' this hour.';
      toast(msg);
      announce(msg + ' Your chance is now ' + pct(state.entries.mine, state.entries.total) + '.');
      resetPick();
    }).catch(function (err) { toast(err.message); }).then(function () {
      buying = false;
      if (state) renderGetIn(state);
    });
  });


  // THE WALLET PILL, one implementation written three times on purpose.
  //
  // It carries its OWN shortener rather than calling the file's. Earlier today
  // this exact block was copied between two views whose shorteners are named
  // short() and who() -- the second threw ReferenceError on every render,
  // silently, and the pill simply never updated. And the duel's who() answers
  // "You" for your own address, which is right in a list of players and wrong on
  // a pill whose whole job is to show WHICH address. Self-contained is cheaper
  // than correct-by-coincidence.
  function renderWallet(s) {
    var a = s && s.wallet && s.wallet.address;
    if (a) {
      el.wallet.textContent = a.slice(0, 6) + '\u2026' + a.slice(-4);
      el.wallet.title = a + ' \u2014 click to disconnect';
      el.wallet.classList.add('is-connected');
      el.wallet.disabled = false;
    } else {
      el.wallet.textContent = 'Connect wallet';
      el.wallet.removeAttribute('title');
      el.wallet.classList.remove('is-connected');
      el.wallet.disabled = false;
    }
  }

  el.wallet.addEventListener('click', function () {
    var D = window.SplashHourly;
    if (el.wallet.classList.contains('is-connected')) {
      D.disconnect().then(function (res) { toast(res.message); }).catch(function (err) { toast(err.message); });
      return;
    }
    D.connectWallet().then(function (res) { toast(res.message); }).catch(function (err) { toast(err.message); });
  });

  /* ---- Loading, errors ------------------------------------------------------------------- */
  function showError(message) {
    window.clearTimeout(loadingTimer);
    body.classList.remove('is-loading');
    if (state) { toast(message); return; }
    body.classList.add('is-offline');
    el.statusText.textContent = message;
    el.retry.hidden = false;
  }

  function startLoading() {
    body.classList.add('is-loading');
    body.classList.remove('is-offline');
    el.retry.hidden = true;
    el.statusText.textContent = 'Reading the realm…';
    loadingTimer = window.setTimeout(function () { el.statusText.textContent = 'Still reading the realm — the chain may be slow.'; }, STILL_LOADING_MS);
    window.SplashHourly.start();
  }
  el.retry.addEventListener('click', startLoading);

  window.SplashHourly.onChange(function (evt) {
    if (evt.type === 'state') render(evt.state);
    else if (evt.type === 'entry') splash(evt.count);
    else if (evt.type === 'error') showError(evt.message);
  });

  window.addEventListener('hashchange', function () {
    if (!/^#demo-[a-z]+$/.test(window.location.hash)) return;
    state = null;
    prev = null;
    buying = false;
    resetPick();
    el.lagoon.classList.remove('is-drawing', 'is-drawn', 'is-final');
    el.winner.hidden = true;
    window.scrollTo(0, 0);
    startLoading();
  });

  window.setInterval(tick, 1000);
  startLoading();
})();
